export { default as TooltipSingletonTarget } from './TooltipSingletonTarget';
